import { render } from "./Rookies.vue?vue&type=template&id=57d1bab8&lang=pug"
import script from "./Rookies.vue?vue&type=script&lang=ts"
export * from "./Rookies.vue?vue&type=script&lang=ts"

import "./Rookies.vue?vue&type=style&index=0&id=57d1bab8&lang=scss"
script.render = render

export default script